import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Icon from 'react-eva-icons';

import styles from './linear-navigation.module.scss';

function LinearNavigation({ item, allItems, onBack, onNext, isStrict }) {
  const totalCount = allItems.length;

  const currentIndex = useMemo(() => {
    return allItems.findIndex((i) => i.id === item.id) + 1;
  }, [allItems, item]);

  return (
    <nav className={styles.container}>
      <button className={styles.button} onClick={onBack} disabled={currentIndex === 1}>
        <Icon size="medium" name="arrow-ios-back-outline" />
        Back
      </button>
      <div className={styles.count}>
        {currentIndex} of {totalCount}
      </div>
      <button
        className={styles.button}
        onClick={onNext}
        disabled={currentIndex === totalCount || (isStrict && !item.completed)}
      >
        Next
        <Icon size="medium" name="arrow-ios-forward-outline" />
      </button>
    </nav>
  );
}

LinearNavigation.propTypes = {
  allItems: PropTypes.array.isRequired,
  isStrict: PropTypes.bool.isRequired,
  item: PropTypes.any.isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  tabIndex: PropTypes.string,
};

LinearNavigation.defaultProps = {
  allItems: [],
  isStrict: false,
  item: {},
  onBack: () => {},
  onNext: () => {},
};

export default LinearNavigation;
